import React from 'react'

function NotfoundUi({ title }) {
    return (
        <div className='flex justify-center items-center h-[50vh]'>
            <div className='py-2 text-center text-[#339A80] text-[20px] text-bold'>{title}</div>
        </div>
    )
}

export default NotfoundUi